import React from "react"

import Divider from "./Divider";
import EditCoachingPlanHead, { ViewState } from "./EditCoachingPlanHead";
import WeeklyPlanEditor from "./WeeklyPlanEditor";
import PersonalRoutineEditor from "./PersonalRoutineEditor";

const FutureWeekView = ({
    activityStats,
    coachingPlan,
    constPlan = null,
    name,
    selectedWeek,
    vetKitVersion = null,
    weekOptions,
    // Callbacks
    goToCurrentWeek,
    onAddWeeks,
    onChangeWeek,
    onConfirmAddWeeks,
    onSaveChanges,
    setBonusActivityCallback,
    setBonusDurationCallback,
    setBonusOptionsCallback = null,
    setPersonalRoutineOptionsCallback = null
}) => {
    return (
        <div className="w-[100%] p-10 flex-col justify-center items-center gap-y-6 inline-flex">
            <div id="head" className="w-full justify-center items-center gap-x-3 inline-flex">
                <EditCoachingPlanHead
                    selectedWeek={selectedWeek}
                    state={ViewState.Pending}
                    weekOptions={weekOptions}
                    // Callbacks
                    goToCurrent={goToCurrentWeek}
                    onAddWeeks={onAddWeeks}
                    onConfirmAddWeeks={onConfirmAddWeeks}
                    onSaveChanges={onSaveChanges}
                    setSelectedWeekCallback={onChangeWeek}
                />
            </div>
            <div id="divider" className="w-full justify-center items-center gap-x-3 inline-flex bg-green-100">
                <Divider label={"Assignments"}/>
            </div>
            <div id="divider" className="w-full justify-center items-center gap-3 inline-flex rounded-[10px] shadow border border-gray-200">
                <PersonalRoutineEditor
                    activityStats
                    firstName={name}
                    state={ViewState.Pending}
                    vetKitVersion={vetKitVersion}
                    // Callbacks
                    setOptionsCallback={setPersonalRoutineOptionsCallback}
                />
            </div>
            <div id="divider" className="w-full justify-center items-center gap-3 inline-flex rounded-[10px] shadow border border-gray-200">
                <WeeklyPlanEditor
                    activityStats={activityStats}
                    coachingPlan={coachingPlan}
                    constPlan={constPlan}
                    selectedWeek={selectedWeek}
                    state={ViewState.Pending}
                    vetKitVersion={vetKitVersion}
                    // Callbacks
                    setOptionCallback={setBonusOptionsCallback}
                    setActivityCallback={setBonusActivityCallback}
                    setDurationCallback={setBonusDurationCallback}
                />
            </div>

        </div>
    )
}

export default FutureWeekView